import * as React from 'react';
import { LogoWrapper, LogoLeftSide, LogoLeftSideRow, LogoRightSide } from './styled';
import { Colors } from '../../../types';

export enum TextLogoProduct {
  Stream = 'STREAM',
  Cinema = 'CINEMA',
}

export interface ITextLogoProps {
  productName: TextLogoProduct;
  color: Colors;
  fontSize?: number;
}

const Logo = ({ color, productName, fontSize = 12 }: ITextLogoProps): React.ReactElement => (
  <LogoWrapper color={color} fontSize={fontSize}>
    <LogoLeftSide color={color}>
      <LogoLeftSideRow>ROYAL</LogoLeftSideRow>
      <LogoLeftSideRow>OPERA</LogoLeftSideRow>
      <LogoLeftSideRow>HOUSE</LogoLeftSideRow>
    </LogoLeftSide>
    <LogoRightSide>{productName}</LogoRightSide>
  </LogoWrapper>
);

export default Logo;
